import { Icon, Icons, Tooltip } from '@silverfort/sf-components';
import ProgressBar from './ProgressBar';

const DetailedProgressBar = ({ description, current, total, fillClassName, frameClassName, className, synced }) => {
    if (isNaN(parseInt(current)) || (total && isNaN(parseInt(total)))) {
        console.error('current and total args must be numbers');
        return;
    }

    return (
        <div className={`h-[28px] flex flex-col gap-1 font-sf text-12 font-medium text-sf-gray-500 ${className}`}>
            <div className="flex h-[18px] items-center justify-between">
                {description && <div className="truncate">{description}</div>}
                {current !== undefined && (
                    <div className="flex items-center gap-1">
                        {synced !== undefined && (
                            <>
                                {synced ? (
                                    <Tooltip title="Virtual Fencing and JIT policies are synced">
                                        <Icon icon={Icons.Sync} className="text-sf-positive-500" />
                                    </Tooltip>
                                ) : (
                                    <Tooltip title="Virtual Fencing and JIT policies are not synced">
                                        <Icon icon={Icons.Sync} />
                                    </Tooltip>
                                )}
                            </>
                        )}
                        <span className="font-sf-poppins text-lg font-bold text-sf-gray-800">{current}</span>
                        {total !== undefined && (
                            <span className="text-lg text-sf-gray-500 font-sf-poppins font-bold">/ {total}</span>
                        )}
                    </div>
                )}
            </div>
            <ProgressBar
                frameClassName={frameClassName}
                fillClassName={fillClassName}
                value={total ? parseInt((current / total) * 100) : 100}
            />
        </div>
    );
};

export default DetailedProgressBar;
